import {
  CountryResponseType,
  ICountryResponse,
} from '../interfaces/country-response.interface';

import { Itinerary } from './itinerary.model';
import { ImageInfo } from './image-info.model';
import { Attraction } from './attraction.model';
import { RegionInfo } from './region-info.model';
import { Destination } from './destination.model';
import { Testimonial } from './testimonial.model';
import { ThingsToDo } from './thinkgs-to-do.model';
import { CountryInfo } from './country-info.model';
import { BlogContent } from './blog-content.model';
import { InitializeField } from './initialize-field.model';
import { NeighbourCountry } from './neighbour-country.model';

export class CountryResponse
  extends InitializeField<ICountryResponse>
  implements CountryResponseType
{
  countryInfo: CountryInfo;
  images: ImageInfo;
  blogContent: BlogContent;
  destinations: Destination[] = [];
  regions: RegionInfo[] = [];
  attractions: Attraction[] = [];
  itineraries: any[] = [];
  testimonials: Testimonial[] = [];
  neighbourCountries: NeighbourCountry[] = [];
  thingsToDo: ThingsToDo[] = [];
  topDest: number;

  // local filters
  attractionsSearchedAndSorted: Attraction[] = [];
  regionsSearchedAndSorted: RegionInfo[] = [];
  destinationsSearchedAndSorted: Destination[] = [];

  protected excludedKeys: string[] = [];

  constructor(data: Partial<ICountryResponse> = {}) {
    super();
    this.topDest = data.topDest;
    this.countryInfo = new CountryInfo(data.country_info);
    this.images = new ImageInfo(data.images);
    this.blogContent = new BlogContent(data.blog_content);
    this.destinations = this.destinationsSearchedAndSorted =
      this.mapToModelArray(data.recommended_destinations, Destination);

    this.regions = this.regionsSearchedAndSorted = this.mapToModelArray(
      data.top_regions || data.regions,
      RegionInfo,
    );

    this.attractions = this.attractionsSearchedAndSorted = this.mapToModelArray(
      data.top_attractions,
      Attraction,
    );

    this.itineraries = this.mapToModelArray(
      data.suggested_itineraries,
      Itinerary,
    );

    this.testimonials = this.mapToModelArray(data.testimonials, Testimonial);

    this.neighbourCountries = this.mapToModelArray(
      data.neighbour_countries,
      NeighbourCountry,
    );

    this.thingsToDo = this.mapToModelArray(
      data.$thingsToDoExtraDescription,
      ThingsToDo,
    );
  }

  protected getDefaultValue(key: string): any {
    switch (key) {
      default:
        return null;
    }
  }

  filterAndSortRegions(value: { searchInput: string; sortDir: string }): void {
    const { searchInput, sortDir } = value;

    const filteredRegions = this.regions.filter(
      (region: any) =>
        region?.name &&
        region?.name?.toLowerCase().includes(searchInput?.toLowerCase()),
    );

    this.regionsSearchedAndSorted = filteredRegions.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();

      if (nameA < nameB) return sortDir === 'asc' ? -1 : 1;
      if (nameA > nameB) return sortDir === 'asc' ? 1 : -1;
      return 0;
    });
  }

  filterAndSortAttractions(value: {
    searchInput: string;
    sortDir: string;
  }): void {
    const { searchInput, sortDir } = value;

    const filteredAttractions = this.attractions.filter(
      (attraction: any) =>
        attraction?.name &&
        attraction?.name?.toLowerCase().includes(searchInput?.toLowerCase()),
    );

    this.attractionsSearchedAndSorted = filteredAttractions.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();

      if (nameA < nameB) return sortDir === 'asc' ? -1 : 1;
      if (nameA > nameB) return sortDir === 'asc' ? 1 : -1;
      return 0;
    });
  }

  filterAndSortDestination(value: {
    searchInput: string;
    sortDir: string;
  }): void {
    const { searchInput, sortDir } = value;

    const filteredDestinations = this.destinations.filter(
      (attraction: any) =>
        attraction?.name &&
        attraction?.name?.toLowerCase().includes(searchInput?.toLowerCase()),
    );

    this.destinationsSearchedAndSorted = filteredDestinations.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();

      if (nameA < nameB) return sortDir === 'asc' ? -1 : 1;
      if (nameA > nameB) return sortDir === 'asc' ? 1 : -1;
      return 0;
    });
  }
}
